export default "__VITE_ASSET__DAKbNWXq__"